import React, { useEffect, useState, useRef } from "react";
import { Box, Steps } from "../../../components";
import styles from "./WeddingWebsite.module.css";
import { useDispatch, useSelector } from "react-redux";
import { Skeleton } from "antd";

import Screen1 from "./Screen1/Screen1";
import Screen2 from "./Screen2/Screen2";
import Screen3 from "./Screen3/Screen3";
import Screen4 from "./Screen4/Screen4";
import Screen5 from "./Screen5/Screen5";
import Screen6 from "./Screen6/Screen6";
import { EventMiddleware } from "../../../Store/Middlewares/EventMiddleware";
const WeddingWebsite = () => {
  const [currentStep, setCurrentStep] = useState(1);
  const [profileImg, setProfileImg] = useState();
  const [loading, setLoading] = useState(true);

  const EventDetails = useSelector((state) => state.EventReducer.EventDetails);
  const WeddingWeb = useSelector((state) => state.EventReducer.WeddingWeb);

  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(EventMiddleware.getWeddingWebsite(EventDetails?.id))
      .then(() => {
        setCurrentStep(WeddingWeb?.next_step ? WeddingWeb?.next_step : 1);
        setLoading(false);
      })
      .catch(() => setLoading(false));
  }, []);


  const stepLinks = [
    {
      id: 1,
    },
    {
      id: 2,
    },
    {
      id: 3,
    },
    {
      id: 4,
    },
    {
      id: 5,
    },
    {
      id: 6,
    },
  ];

  // useEffect(() => {
  //   setCurrentStep(stepLinks[0].id);
  // }, []);
  return (
    <div>
      {/* <h1>Wedding Website</h1> */}
      <Steps
        stepLinks={stepLinks}  
        currentStep={currentStep}
        setCurrentStep={setCurrentStep}
        stepperClass={styles.stepperCont}
      />
      <Box boxClass={styles.mainCont}>
        <div
          className={styles.backImg}
          style={
            WeddingWeb?.background_image
              ? {
                  backgroundImage: `linear-gradient(rgba(255,255,255,0.6 ), rgba(255,255,255,0.6)),url(${WeddingWeb?.background_image})`,
                }
              : {}
          }
        >
          <Skeleton loading={loading}>
            {currentStep == 1 ? ( 
              <Screen1
                setCurrentStep={setCurrentStep}
                // profileImg={profileImg}
                // setProfileImg={setProfileImg}
              />
            ) : currentStep == 2 ? (
              <Screen2
                profileImg={profileImg}
                setCurrentStep={setCurrentStep}
              />
            ) : currentStep == 3 ? (
              <Screen3
                profileImg={profileImg}
                setCurrentStep={setCurrentStep}
              />
            ) : currentStep == 4 ? (
              <Screen4
                profileImg={profileImg}
                setCurrentStep={setCurrentStep}
              />
            ) : currentStep == 5 ? (
              <Screen5
                profileImg={profileImg}
                setCurrentStep={setCurrentStep}
              />
            ) : currentStep == 6 ? (
              <Screen6
                profileImg={profileImg}
                setCurrentStep={setCurrentStep}
              />
            ) : null}
          </Skeleton>
        </div>
      </Box>
    </div>
  );
};

export default WeddingWebsite;
